







































import Vue from 'vue'
import Component from 'vue-class-component'
// @ts-ignore
import ClickOutside from 'vue-click-outside'

@Component({
  props: {
    value: {
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Edit...'
    },
    error: {
      type: Boolean,
      default: false
    },
    closeEvents: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputSelector: {
      type: String,
      default: 'input'
    },
    fieldName: {
      type: String,
      default: ''
    },
    noMinHeight: {
      type: Boolean,
      default: false,
    }
  },
  directives: {
    ClickOutside
  }
})
export default class Editable extends Vue {
  showInput: boolean = false
  height: string | number | null = null
  tabindex: number = 0
  isIgnoreClickOutside: boolean = false

  get hasValue () {
    return this.$props.value || parseInt(this.$props.value, 10) === 0 || this.$props.value === '0'
  }

  onClick () {
    if (this.showInput || this.$props.disabled) {
      return
    }
    this.tabindex = -1
    this.setMinHeight()
    this.showInput = true
    this.$nextTick(() => {
      this.$el.querySelector(this.$props.inputSelector).focus()
      this.$forceUpdate()
    })
  }

  focusInput (name: string) {
    if (this.$props.fieldName === name) {
      this.isIgnoreClickOutside = true
      this.onClick()
      setTimeout(() => {
        this.isIgnoreClickOutside = false
      }, 0)
    }
  }

  close () {
    if (!this.$props.error && !this.isIgnoreClickOutside) {
      this.tabindex = 0
      this.showInput = false
    }
    this.resetMinHeight()
  }

  setMinHeight () {
    const height: number | null = (this.$el as any).offsetHeight
    this.height = height && height >= 32 ? height : 32
  }

  resetMinHeight () {
    this.height = 32
  }

  mounted () {
    this.$eventBus.$on('focusInput', this.focusInput)

    // @ts-ignore
    if (!this.$slots || !this.$slots['default'] || !this.$slots['default'][0]) {
      throw new Error('Input is not provided')
    }
    // @ts-ignore
    // this.$slots['default'][0].componentInstance.$on('focus', this.onClick)

    this.$props.closeEvents.forEach((event: string) => {
      // @ts-ignore
      this.$slots['default'][0].componentInstance.$on(event, this.close)
    })

    this.$watch('value', () => {
      this.$nextTick(() => this.setMinHeight())
    })
  }

  beforeDestroy () {
    this.$eventBus.$off('focusInput', this.focusInput)
    // @ts-ignore
    if (this.$slots && this.$slots['default'] && this.$slots['default'][0]) {
      this.$props.closeEvents.forEach((event: string) =>
        // @ts-ignore
        this.$slots['default'][0].componentInstance.$off(event, this.close))
    }
  }
}
